/**
 * OrbDocTutorialsBeginnerCompleteOrbitalARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsBeginnerCompleteOrbitalARDocScreen
 */

import { useOrbDocTutorialsBeginnerCompleteOrbitalARDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsBeginnerCompleteOrbitalARDocScreenLogic';
import type { OrbDocTutorialsBeginnerCompleteOrbitalARDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsBeginnerCompleteOrbitalARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsBeginnerCompleteOrbitalARDocView as OrbDocTutorialsBeginnerCompleteOrbitalARDocViewEntity } from '@app/shared';
import { OrbDocTutorialsBeginnerCompleteOrbitalARDocBodyView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalARDocBodyView';
import { OrbDocTutorialsBeginnerCompleteOrbitalARDocFooterView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalARDocFooterView';
import { OrbDocTutorialsBeginnerCompleteOrbitalARDocHeaderView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsBeginnerCompleteOrbitalARDocScreenViewProps {
  config?: Partial<OrbDocTutorialsBeginnerCompleteOrbitalARDocScreenConfig>;
}

export function OrbDocTutorialsBeginnerCompleteOrbitalARDocScreenView({ config: propsConfig }: OrbDocTutorialsBeginnerCompleteOrbitalARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsBeginnerCompleteOrbitalARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsBeginnerCompleteOrbitalARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsBeginnerCompleteOrbitalAR" trait="OrbDocTutorialsBeginnerCompleteOrbitalARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsBeginnerCompleteOrbitalARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsBeginnerCompleteOrbitalARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsBeginnerCompleteOrbitalARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsBeginnerCompleteOrbitalARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsBeginnerCompleteOrbitalARDocScreenView;
